function pad(value) {
  return String(value).padStart(2, '0');
}

export function toDateInputValue(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function parseDateInput(value) {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function startOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

function endOfWeek(date) {
  const d = startOfWeek(date);
  d.setDate(d.getDate() + 6);
  return d;
}

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function startOfYear(date) {
  return new Date(date.getFullYear(), 0, 1);
}

function endOfYear(date) {
  return new Date(date.getFullYear(), 11, 31);
}

export function getPresetRange(label, baseDate = new Date()) {
  const today = new Date(baseDate);
  today.setHours(0, 0, 0, 0);

  if (label === 'Today') return { startDate: toDateInputValue(today), endDate: toDateInputValue(today) };

  if (label === 'Previous Day') {
    const d = new Date(today);
    d.setDate(d.getDate() - 1);
    return { startDate: toDateInputValue(d), endDate: toDateInputValue(d) };
  }

  if (label === 'This Week') {
    return { startDate: toDateInputValue(startOfWeek(today)), endDate: toDateInputValue(endOfWeek(today)) };
  }

  if (label === 'Previous Week') {
    const d = startOfWeek(today);
    d.setDate(d.getDate() - 7);
    return { startDate: toDateInputValue(d), endDate: toDateInputValue(endOfWeek(d)) };
  }

  if (label === 'This Month') {
    return { startDate: toDateInputValue(startOfMonth(today)), endDate: toDateInputValue(endOfMonth(today)) };
  }

  if (label === 'Previous Month') {
    const d = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    return { startDate: toDateInputValue(startOfMonth(d)), endDate: toDateInputValue(endOfMonth(d)) };
  }

  if (label === 'This Year') {
    return { startDate: toDateInputValue(startOfYear(today)), endDate: toDateInputValue(endOfYear(today)) };
  }

  if (label === 'Previous Year') {
    const d = new Date(today.getFullYear() - 1, 0, 1);
    return { startDate: toDateInputValue(startOfYear(d)), endDate: toDateInputValue(endOfYear(d)) };
  }

  return { startDate: toDateInputValue(today), endDate: toDateInputValue(today) };
}

export function getDefaultDateRange() {
  return getPresetRange('This Month');
}
